import React from "react";
import "./AttendeesAvatar.scss";

const AttendeesAvatar = ({ attendees }) => {
  const getRandomColor = () => {
    const colors = [
      "#FF5733", // red-ish
      "#33FF57", // green-ish
      "#3357FF", // blue-ish
      "#F39C12", // orange
      "#9B59B6", // purple
      "#3498DB", // light blue
      "#E74C3C", // light red
      "#2ECC71", // light green
    ];
    return colors[Math.floor(Math.random() * colors.length)]; // Choose a random color
  };

  const displayedAttendees = attendees.slice(0, 3); // Show only the first 3
  const extraAttendees = attendees.length - 3; // Calculate how many extra attendees

  return (
    <div className="avatar-group text-uppercase">
      {displayedAttendees.map((attendees, index) => (
        // Additional logic will be added here
        // Attendees Initials will be taken from interview.emails object
        <div
          key={index}
          className="avatar"
          // style={{ backgroundColor: getRandomColor() }}
        >
          {attendees}
        </div>
      ))}
      {extraAttendees > 0 && (
        <div className="extra-attendees"> + {extraAttendees}</div>
      )}
    </div>
  );
};

export default AttendeesAvatar;
